/// <reference path='../../interfaces/interfaces.d.ts' />

import {IStateService} from 'angular-ui-router';
'use strict';

class NewModalEventController {
    public static $inject = [
        '$rootScope',
        '$state',
        '$uibModalInstance',
        'Orgs',
        'User',
        'Calendar',
        'selectedDate',
        'toaster',
        'bsLoadingOverlayService',
    ];

    public occurrences;
    public datePickerConfig;
    public hasPermission;
    public repeatCases;
    public eventTypes;
    public calType;
    public eventTypeIcons;
    public event: any = {
        description: '',
        title: '',
        type: 0,
        day: undefined,
        start: undefined,
        startTime: undefined,
        end: undefined,
        endTime: undefined,

        calendar_type: undefined,
        rule: '',
        allDay: false
    };

    constructor(
        private $scope: ng.IScope,
        private $state: IStateService,
        private $uibModalInstance: any,
        private Org: IOrgsService,
        private User: IUserService,
        private Calendar: ICalendarService,
        private selectedDate: moment.Moment,
        private toaster: toaster.IToasterService,
        private bsLoadingOverlayService: IBsLoadingService) {

        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.hasPermission = User.hasPermission;
        this.repeatCases = Calendar.getRepeatCases();
        this.eventTypes = Calendar.getEventTypes();
        this.eventTypeIcons = Calendar.getEventTypeIcons();

        let startDateTime = selectedDate.clone().hour(moment().hour()).minute(moment().minute());
        this.event.start = startDateTime.clone().startOf('day').toDate();
        this.event.startTime = startDateTime.toDate();
        this.event.end = startDateTime.clone().startOf('day').toDate();
        this.event.endTime = startDateTime.clone().add(15, 'm').toDate();

        this.datePickerConfig = {
            formatDay: 'd',
            formatDayTitle: 'MMM yyyy',
            showWeeks: false,
            minDate: this.selectedDate.toDate()
        };
    }

    public changeAllDay = () => {

        if (this.event.allDay) {
            this.event.startTime = moment(this.event.start).hour(0).minute(0);
            this.event.endTime = moment(this.event.end).hour(23).minute(59);
        } else {
            this.event.startTime = moment(this.event.start).hour(0).minute(0);
            this.event.endTime = moment(this.event.end).hour(23).minute(45);
        }
    }

    public addEvent = (form: ng.IFormController) => {
        form.$submitted = true;

        // ////////////////////
        // Validate form inputs

        // Make sure all required fields are filled in
        if (!form.$valid) {
            this.toaster.pop('error', 'Error saving event', 'Required fields are not filled correctly');
            return;
        }

        // Check that start time is before end time
        if (this.event.startTime > this.event.endTime) {
            this.toaster.pop('warning', 'Validation Failed', 'Starting time must be earlier than the end time');
            return;
        }

        //
        this.event.end_recurring_period = (this.event.ends !== 'never')
            ? this.event.end_recurring_period
            : undefined;

        if (this.event.ends === 'on') {
            this.event.end_recurring_period.setMinutes(moment(this.event.start).toDate().getMinutes());
        }
        let startDate: Moment = moment(this.event.start);
        let endDate: Moment = moment(this.event.end);
        let ddiff: number = endDate.diff(startDate, 'days');

        if (ddiff > 0) {
            this.event.allDay = true;
            this.event.start = moment(this.event.start).hour(0).minute(0);
            this.event.end = moment(this.event.end).hour(23).minute(59);
        }

        let promise: any;
        if (this.event.calendar_type === 'holidays') {
            this.event.start = startDate;
            this.event.end = endDate;
            promise = this.Calendar.createHoliday(this.event);
        } else {
            if (!this.event.event_type) {
                this.toaster.pop('error', 'Validation failed', 'Please select event type');
                return;
            }
            promise = this.Calendar.createEvent(this.event);
        }

        // API call to server and handle the responses
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        promise.then((response: Restangular.IResponse) => {
            this.$scope.$emit('$EL', 'calendar.add_event');

            this.$uibModalInstance.close(response);
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            this.toaster.pop('success', 'Success', 'Event successfully added');

            // update announcement count
            this.$scope.$emit('$incrementAnnounceCounter');
        }, (response: Restangular.IResponse) => {
            if (response.status === 400) {
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                this.toaster.pop('error', 'Validation Failed', response.data);
            } else {
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                this.toaster.pop('error', 'Server error', 'Please try again later');
            }
        });
    }

    public fullEventEditor = (event: ng.IFormController) => {
        this.$uibModalInstance.dismiss('cancel');

        switch (this.$state.$current['self']['name']) {
            case 'root.calendar': {
                this.$state.go('root.calendar.add', {tempEvent: this.event });
                break;
            }
            case 'root.employees.details.calendar': {
                this.$state.go('root.employees.details.calendar.add', {tempEvent: this.event });
                break;
            }
            default: {
                this.$state.go('root');
            }
        }
    }

    public setEventType(event: any): void {
        this.event.event_type = event;
    }

    public occurrencesChange(): void {
        if (this.occurrences > 0) {
            this.occurrences = parseInt(this.occurrences, 10);
            let dateDifferance: number = this.occurrences - 1;
            let newDate: any = this.event.start.toDate();

            switch (this.event.rule) {
                case 'daily': {
                    newDate.setDate(newDate.getDate() + dateDifferance);
                    break;
                }
                case 'weekly': {
                    dateDifferance = this.occurrences * 7 - 1;
                    newDate.setDate(newDate.getDate() + dateDifferance);
                    break;
                }
                case 'monthly': {
                    newDate.setMonth(newDate.getMonth() + dateDifferance);
                    break;
                }
                case 'yearly': {
                    newDate.setFullYear(newDate.getFullYear() + dateDifferance);
                    break;
                }
                    default: 
            }

            newDate.setMinutes(newDate.getMinutes() + 1);
            this.event.end_recurring_period = newDate;
        } else {
            this.occurrences = undefined;
            this.toaster.pop('warning', 'Validation Failed', 'Event occurrences count must be a positive number!');
        }
    }
}

angular.module('beneple.calendar').controller('NewModalEventController', NewModalEventController);



// WEBPACK FOOTER //
// ./frontend/scripts/calendar/controllers/new-modal-event.controller.ts